import { render, staticRenderFns } from "./editServiceFeeDialog.vue?vue&type=template&id=40916248&scoped=true"
import script from "./editServiceFeeDialog.vue?vue&type=script&lang=js"
export * from "./editServiceFeeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40916248",
  null
  
)

export default component.exports